import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=155879b2"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports